<template>
  <form>
    <v-row class="py-0">
      <v-col class="py-0" cols="12" sm="12" md="11" lg="11">
        <form-edit
          :form="salePayment"
          :customers="customers"
          :listBank="listBank"
          :listInvoice="listInvoice"
          ref="formEdit"
          v-if="!edit"
        ></form-edit>
        <detail :id="id" :form="salePayment" :listBank="listBank" v-if="edit"></detail>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-btn v-if="$rbac.can('sale-payment.update')" color="success" @click="updateItem">
              <v-icon>
                mdi-content-save
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit && salePayment.approved">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('sale-payment.print')"
                  color="warning"
                  v-on="on"
                  @click="routeToPrintPreview"
                >
                  <v-icon>
                    mdi-printer
                  </v-icon>
                </v-btn>
              </template>
              <span>Print Preview</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit && !salePayment.approved && !salePayment.hidden">
          <v-col cols="12" class="py-0">
            <v-btn v-if="$rbac.can('sale-payment.update')" color="success" @click="editItem">
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit && !salePayment.hidden">
          <v-col cols="12" class="py-0">
            <v-btn v-if="$rbac.can('sale-payment.delete')" color="error" @click.stop="deleteDialog">
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click="cancel">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" @click="back">
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="blue-grey" dark v-on="on" @click="dialogAuditHistory = true">
                  <v-icon>
                    mdi-history
                  </v-icon>
                </v-btn>
              </template>
              <span>History</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-delete
      :id="id"
      :dialog="dialog"
      :invoiceNumber="salePayment.formNumber"
      title="Sale Payment"
      @deleteItem="openRemark"
      @close="close"
    ></dialog-delete>
    <dialog-cancel :dialog="dialogRemark" @save="deleteItem" @close="closeRemark"></dialog-cancel>

    <dialog-audit-history
      :dialog="dialogAuditHistory"
      entity-type="SalePayment"
      :entity-id="id"
      @close="dialogAuditHistory = false"
    ></dialog-audit-history>
  </form>
</template>

<script>
import Detail from "./DetailSalePayment";
import FormEdit from "./FormSalePayment";
import DialogDelete from "@/components/DialogDelete";
import DialogCancel from "./DialogCancel.vue";
import { mapState } from "vuex";
import DialogAuditHistory from "@/components/DialogAuditHistory.vue";

export default {
  name: "sale-invoice-view",
  components: {
    Detail,
    "form-edit": FormEdit,
    "dialog-delete": DialogDelete,
    DialogCancel,
    DialogAuditHistory,
  },
  props: {
    id: Number,
  },
  data: () => ({
    edit: true,
    dialog: false,
    dialogRemark: false,
    dialogAuditHistory: false,
    listBank: [],
    listInvoice: [],
    salePayment: {},
  }),
  computed: {
    ...mapState("external", ["customers"]),
  },
  methods: {
    async getSalePayment() {
      await this.$store.dispatch("salePayment/getById", this.id).then(async response => {
        this.salePayment = response.data;
        await this.$store
          .dispatch("salePayment/getListInvoice", response.data.customerId)
          .then(response => {
            this.listInvoice = response.data;
          });
      });
    },
    async getBank() {
      this.$store.dispatch("chartOfAccount/getBanks").then(response => {
        this.listBank = response.data;
      });
    },
    back() {
      this.$router.go(-1);
    },
    editItem() {
      this.edit = false;
    },
    updateItem() {
      this.$refs.formEdit.checkJournal();
    },
    async deleteItem(remark) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("salePayment/delete", { id: this.id, remark: remark })
        .then(() => {
          this.close();
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    deleteDialog() {
      this.dialog = true;
    },
    openRemark() {
      this.dialogRemark = true;
    },
    close() {
      this.dialog = false;
    },
    closeRemark() {
      this.dialogRemark = false;
    },
    cancel() {
      this.getSalePayment();
      this.edit = true;
    },
    routeToPrintPreview() {
      this.$router.push({ name: "Print Preview Sale Payment", params: { id: this.id } });
    },
    async getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([
        this.getSalePayment(),
        this.getBank(),
        await this.$store.dispatch("external/getCustomers"),
      ])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
  mounted() {
    this.getInitialData();
  },
};
</script>

<style></style>
